import _ from 'lodash/fp';

export const removeHyphen = (x) => _.pipe(_.toString, _.replace(/-/g, ''))(x);
export const removeCommas = (x) => _.pipe(_.toString, _.replace(/,/g, ''))(x);
export const numberWithCommas = (x) => {
	if (!x) return 0;
	return _.pipe(removeCommas, _.replace(/\B(?=(\d{3})+(?!\d))/g, ','))(x);
};
export const convertToNumber = (x) => _.pipe(removeCommas, _.toNumber)(x);
export const phoneWithHyphen = (x) =>
	x &&
	x
		.replace(/[^0-9]/g, '')
		.replace(/(^02|^0502|^0504|^0505|^0506|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})/, '$1-$2-$3')
		.replace('--', '-');
export const numberWithHyphen = (x) => x && x.replace(/[^0-9]/g, '').replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]+)?([0-9]{4})/, '$1-$2-$3');
export const businessNumberWithHyphen = (x) => x && x.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
export const cutting10units = (num) => Math.floor(num / 100) * 100;
